import { DETERMINAR_PAGINA_ATUAL_MDFE } from '../../actions/types'

export default function reducerPaginaAtualMdfe(state = 1, action = undefined) {
  switch (action.type) {
    case DETERMINAR_PAGINA_ATUAL_MDFE: {
      return action.payload
    }
    default:
      return state
  }
}
